export const mmDDYYYY = 'MM/DD/YYYY';


// WEBPACK FOOTER //
// ./src/utils/placeHolderFormat.js